﻿import { age_category } from "./age_category";

export class age_cat {
    public default_category: string = "";
    public categories: age_category[] = [];
}
